import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AlertDialogComponent, AlertDialogModel } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';

export interface JobOrderDataStatesFilters {
  fileName: string;
  date: string;
  fromDate: Date;
  toDate: Date;
}

enum DateFilterEnum {
  NONE = 'NONE',
  THIS_YEAR = 'THIS_YEAR',
  THIS_MONTH = 'THIS_MONTH',
  TODAY = 'TODAY',
  CUSTOM = 'CUSTOM',
}

@Component({
  selector: 'app-job-order-data-state-filter-component',
  templateUrl: './job-order-data-state-filter.component.html',
  styleUrls: ['./job-order-data-state-filter.component.scss'],
})
export class JobOrderDataStateFilterComponent implements OnInit {
  @Output()
  apply: EventEmitter<JobOrderDataStatesFilters> = new EventEmitter();

  @Output()
  viewAllSelected: EventEmitter<void> = new EventEmitter();

  formGroup = new FormGroup({
    fileName: new FormControl(''),
    date: new FormControl(DateFilterEnum.NONE),
    fromDate: new FormControl({ value: '', disabled: true }),
    toDate: new FormControl({ value: '', disabled: true }),
  });

  disableApply = true;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {}

  onChange() {
    switch (this.formGroup.value.date) {
      case 'CUSTOM': {
        // Enable custom date selection fields
        this.formGroup.controls.fromDate.reset({
          value: this.formGroup.value.fromDate,
          disabled: false,
        });
        this.formGroup.controls.toDate.reset({
          value: this.formGroup.value.toDate,
          disabled: false,
        });
        break;
      }
      default: {
        this.formGroup.controls.fromDate.reset({
          value: this.formGroup.value.fromDate,
          disabled: true,
        });
        this.formGroup.controls.toDate.reset({
          value: this.formGroup.value.toDate,
          disabled: true,
        });
      }
    }
    this.disableApply = false;
  }

  onApply() {
    let fromDate = this.formGroup.value.fromDate;
    let toDate = this.formGroup.value.toDate;
    const today = new Date();
    switch (this.formGroup.value.date) {
      case 'CUSTOM':
        if(fromDate === undefined || toDate === undefined){
          const dialogData = new AlertDialogModel(
            'Error during filter application',
            'Please, fill both date fields in order to apply filters'
          );
          this.dialog.open(AlertDialogComponent, {
            data: dialogData,
          });
          return;
        }
        break;
      case 'THIS_YEAR':
        fromDate = new Date(new Date().getFullYear(), 0, 1);
        toDate = new Date(new Date().getFullYear(), 11, 31);
        break;

      case 'THIS_MONTH':
        fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
        toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;

      case 'TODAY':
        fromDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          1
        );
        toDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          23,
          59
        );
        break;

      default:
        break;
    }
    this.apply.emit({
      ...this.formGroup.value,
      fromDate,
      toDate,
    });
  }

  onViewAllSelected() {
    this.viewAllSelected.emit();
  }
}
